module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [(_vm.firstName) ? _c('span', [_vm._v(_vm._s(_vm.firstName) + ", ")]) : _vm._e(), _vm._v(" Thanks for your donation.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_c('p', [_vm._v("Thank you "), (_vm.firstName) ? _c('span', [_vm._v(_vm._s(_vm.firstName) + " ")]) : _vm._e(), (_vm.lastName) ? _c('span', [_vm._v(_vm._s(_vm.lastName))]) : _vm._e(), _vm._v(" for your\n    "), (_vm.frequency) ? _c('span', [_vm._v(_vm._s(_vm.frequency))]) : _vm._e(), _vm._v(" gift\n    "), (_vm.amount) ? _c('span', [_vm._v("\n      of "), _c('span', {
    staticClass: "amount"
  }, [_vm._v("$ " + _vm._s(_vm.amount))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd69dfc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/ThankYouDonation.vue
// module id = 642
// module chunks = 0